import * as React from "react";
import { NavLink } from "react-router-dom";
import { GeneralAction } from "actions/general-action";
import { getFirstAvailableSubMenuRoute } from "../../../../utils/navigationUtils";

const BrandingSection = ({
  isParentMenuAvailable,
  getParentMenuSortOrder,
  getParentMenuDisplayNumber,
  isChildMenuItemAvailable,
  activeBrandingStep,
  dispatch,
  history,
  t,
  toggle,
  onToggle,
  completed_modules,
  in_array,
  menuHierarchy,
}) => {
  if (!isParentMenuAvailable("branding")) return null;
  
  // Get the first available sub-menu route for branding
  const firstAvailableRoute = getFirstAvailableSubMenuRoute("branding", menuHierarchy);

  // Get children for this parent from menuHierarchy, sorted by sort_order
    const brandingNode = Array.isArray(menuHierarchy)
      ? menuHierarchy.find((item) => item.alias === "branding")
      : null;

  const sortedChildren =
    brandingNode && Array.isArray(brandingNode.children)
      ? [...brandingNode.children]
          .filter((child) => isChildMenuItemAvailable("branding", child.alias))
          .sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0))
      : [];

  const renderChildItem = (child) => {
    switch (child.alias) {
      case "branding":
        return (
          <li key={child.id}>
            {activeBrandingStep === "branding" ||
            (window.location.pathname.includes("/event/settings/branding") && !activeBrandingStep) ? (
              <span className="active">Branding</span>
            ) : (
              <span
                style={{ cursor: "pointer" }}
                onClick={() => {
                  dispatch(GeneralAction.step("branding"));
                  history.push("/event/settings/branding");
                }}
                className={activeBrandingStep === "branding" ? "activeCompleted" : ""}
              >
                {t("M_EVENT_BRANDING")}
              </span>
            )}
          </li>
        );
      case "reg_site_header_and_footerex":
        return (
          <li key={child.id}>
            <span onClick={() => onToggle && onToggle()} style={{ cursor: "pointer" }}>
              {activeBrandingStep === "opening-hour" ||
              activeBrandingStep === "contact-person" ||
              activeBrandingStep === "registration-setting" ? (
                <span className="active">{t("REG_SITE_FOOTER")}</span>
              ) : (
                <span>{t("REG_SITE_FOOTER")}</span>
              )}
              <i className="material-symbols-outlined">expand_more</i>
            </span>
            {toggle && (
              <ul style={{ display: "block", cursor: "pointer" }}>
                <li>
                  {activeBrandingStep === "opening-hour" ||
                  (window.location.pathname.includes("/event/settings/opening-hour") &&
                    !activeBrandingStep) ? (
                    <span className="active">{t("EVENT_OPENING_HOURS")}</span>
                  ) : (
                    <span
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        dispatch(GeneralAction.step("opening-hour"));
                        history.push("/event/settings/opening-hour");
                      }}
                    >
                      {t("EVENT_OPENING_HOURS")}
                    </span>
                  )}
                </li>
                <li>
                  {activeBrandingStep === "contact-person" ||
                  (window.location.pathname.includes("/event/settings/contact-person") &&
                    !activeBrandingStep) ? (
                    <span className="active">{t("CONTACT_PERSONS")}</span>
                  ) : (
                    <span
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        dispatch(GeneralAction.step("contact-person"));
                        history.push("/event/settings/contact-person");
                      }}
                    >
                      {t("CONTACT_PERSONS")}
                    </span>
                  )}
                </li>
                <li>
                  {activeBrandingStep === "registration-setting" ||
                  (window.location.pathname.includes("/event/settings/registration-setting") &&
                    !activeBrandingStep) ? (
                    <span className="active">{t("ATTENDEE_SETTINGS")}</span>
                  ) : (
                    <span
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        dispatch(GeneralAction.step("registration-setting"));
                        history.push("/event/settings/registration-setting");
                      }}
                    >
                      {t("ATTENDEE_SETTINGS")}
                    </span>
                  )}
                </li>
              </ul>
            )}
          </li>
        );
      case "eventsite_banner":
        return (
          <li key={child.id}>
            {activeBrandingStep === "eventsite-banners" ||
            (window.location.pathname.includes("/event/settings/eventsite-banners") &&
              !activeBrandingStep) ? (
              <span className="active">{t("EVENTSITE_BANNERS")}</span>
            ) : (
              <span
                style={{ cursor: "pointer" }}
                onClick={() => {
                  dispatch(GeneralAction.step("eventsite-banners"));
                  history.push("/event/settings/eventsite-banners");
                }}
              >
                {t("EVENTSITE_BANNERS")}
              </span>
            )}
          </li>
        );
      case "website_section":
        return (
          <li key={child.id}>
            {activeBrandingStep === "website-sections" ||
            (window.location.pathname.includes("/event/settings/website-sections") &&
              !activeBrandingStep) ? (
              <span className="active">{t("WEBSITE_SECTIONS")}</span>
            ) : (
              <span
                style={{ cursor: "pointer" }}
                onClick={() => {
                  dispatch(GeneralAction.step("website-sections"));
                  history.push("/event/settings/website-sections");
                }}
              >
                {t("WEBSITE_SECTIONS")}
              </span>
            )}
          </li>
        );
      case "section":
        return (
          <li key={child.id}>
            {activeBrandingStep === "sections" ||
            (window.location.pathname.includes("/event/settings/sections") &&
              !activeBrandingStep) ? (
              <span className="active">{t("SECTIONS")}</span>
            ) : (
              <span
                style={{ cursor: "pointer" }}
                onClick={() => {
                  dispatch(GeneralAction.step("sections"));
                  history.push("/event/settings/sections");
                }}
              >
                {t("SECTIONS")}
              </span>
            )}
          </li>
        );
      case "custom_sections":
        return (
          <li key={child.id}>
            {activeBrandingStep === "custom-sections" ||
            (window.location.pathname.includes("/event/settings/custom-sections") &&
              !activeBrandingStep) ? (
              <span className="active">{t("CUSTOM_SECTIONS")}</span>
            ) : (
              <span
                style={{ cursor: "pointer" }}
                onClick={() => {
                  dispatch(GeneralAction.step("custom-sections"));
                  history.push("/event/settings/custom-sections");
                }}
              >
                {t("CUSTOM_SECTIONS")}
              </span>
            )}
          </li>
        );
      default:
        return null;
    }
  };
  
  return (
    <li
      style={{
        order: getParentMenuSortOrder("branding"),
        counterSet: `section ${getParentMenuDisplayNumber("branding")}`,
      }}
      className={`${
        window.location.pathname.includes("/event/settings/branding") ||
        window.location.pathname.includes("/event/settings/registration-setting") ||
        window.location.pathname.includes("/event/settings/opening-hour") ||
        window.location.pathname.includes("/event/settings/contact-person") ||
        window.location.pathname.includes("/event/settings/eventsite-banners") ||
        window.location.pathname.includes("/event/settings/sections") ||
        window.location.pathname.includes("/event/settings/website-sections") ||
        window.location.pathname.includes("/event/settings/custom-sections")
          ? "bold activeList"
          : ""
      } ${in_array("branding", completed_modules) ? "completed" : ""}`}
    >
      <span>
        <NavLink to={firstAvailableRoute || "/event/settings/branding"} onClick={() => dispatch(GeneralAction.step("branding"))}>
          {t("M_EVENT_BRANDING")}
        </NavLink>
      </span>
      <ul>
        {sortedChildren.map((child) => renderChildItem(child)).filter(Boolean)}
      </ul>
    </li>
  );
};

export default BrandingSection;
